import { LobbyCentralLocationViewState } from './redusers/lobby-central-location-view.reducer';
import { LobbyCentralStaffViewState } from './redusers/lobby-central-staff-view.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LobbyCentralLocationSelectorState } from './redusers/lobby-central-views-location-selector.reducer';
import { LobbyCentralLobbyViewState } from './redusers/lobby-central-lobby.reducer';

export interface State {
    lobbyCentralStaffView: LobbyCentralStaffViewState;
    lobbyCentralLocationView: LobbyCentralLocationViewState;
    lobbyCentralLocationSelector: LobbyCentralLocationSelectorState;
    lobbyCentralView: LobbyCentralLobbyViewState;
    
}

const getLobbyCentralViewFeatureState = createFeatureSelector<State>('lobbyCentralView');



export const getCenralLobyLocations = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralLocationSelector.locationData
);

export const getCenralLobySelectedLocations = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralLocationSelector.selectedLocations
);

export const getCenralLobySelectedLocationIds = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralLocationSelector.selectedLocations.map(l => l.locationId)
);

export const getIsLocationChanged = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralStaffView.isLocationChanged
);

export const getlocationId = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralStaffView.locationId
);

export const getAssistType = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralStaffView.assistType
);

export const getSearchText = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralStaffView.searchText
);

export const getStaffStatusGridData = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralStaffView.data
);

export const searchTextChange = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralStaffView.searchText
);

export const reloadSubscription = createSelector(
    getLobbyCentralViewFeatureState,
    getlocationId,
    getAssistType,
    searchTextChange,
    (state, locationId, assistType, searchText) => {
        return true;
    }
);

export const getCentralLocationGridData = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralLocationView.gridData
);

export const getCentralLocationPageInfo = createSelector(
    getLobbyCentralViewFeatureState,
    state => {
        return {
            page: state.lobbyCentralLocationView.page,
            pageSize: state.lobbyCentralLocationView.pageSize
        };
    }
);

export const getSubscribeToCentralLocationGridData = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralLocationView.subscribeToCentralLocationGridData
);

export const getCentralLocationSortInfo = createSelector(
    getLobbyCentralViewFeatureState,
    state => {
        return {
            sortColumn: state.lobbyCentralLocationView.sortColumn,
            sortDirection: state.lobbyCentralLocationView.sortDirection
        };
    }
);

export const getCentralLocationGridTenantId = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralLocationView.tenantId
);

export const getCentralLocationGridLocationId = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralLocationView.signInLocationId
);

export const getCentralLocationGridFilters = createSelector(
    getCentralLocationGridTenantId,
    getCentralLocationGridLocationId,
    getSubscribeToCentralLocationGridData,
    getCentralLocationPageInfo,
    getCentralLocationSortInfo,
    getCenralLobySelectedLocationIds,
    (tenantId, locationId, requirSubscribe, pageInfo, sortInfo, selectedLocations) => {
        if (requirSubscribe) {
            return {
                TenantId: tenantId,
                SignInLocationId: locationId,
                LocationFilters: selectedLocations,
                Page: pageInfo.page,
                PageSize: pageInfo.pageSize,
                SortColumn: sortInfo.sortColumn,
                SortDirection: sortInfo.sortDirection
            };
        } else {
            return null;
        }
    }
);

export const getCentralLobbyViewGridData = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralView.data
);

export const centralLobbyViewSearchTextChange = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralView.searchText
);

export const centralLobbyViewIsSpanishSpeaker = createSelector(
    getLobbyCentralViewFeatureState,
    state => state.lobbyCentralView.IsSpanishSpeakerChange
);
